<template>
  <div style="width: 100%;">
    <div v-if="pageErrors.length>0" id="pageErrors" class="alert alert-danger">
      <p>
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in pageErrors" :key="error">{{ error }}</li>
        </ul>
      </p>
    </div>
    <div v-if="ProgramLabel">
      <label for="addProgram">
        <b>{{ ProgramLabel }}</b>
      </label>
    </div>
    <form id="ProgramForm" ref="ProgramForm" action>
      <!-- <div
        id="error"
        class="alert alert-danger"
        role="alert"
        v-if="displayErrors"
        v-show="errors.items.length"
      >
        <span v-show="errors.has('ProgramName')" class="alert-danger">
          {{ errors.first('ProgramName') }}
          <br>
        </span>

        <span v-show="errors.has('EIN')" class="alert-danger">
          {{ errors.first('EIN') }}
          <br>
        </span>
      </div> -->
      <div class="form-row">
        <div class="col-md-12 section-title-group accordion-pad">
          <label class="accordion section-title">Program Details</label>
        </div>
      </div>
      <div class="panel">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="required-label">Program (Legal Entity) Name</label>
            <input
              type="text"
              id="txtProgramName"
              name="ProgramName"
              v-model="ProgramInfo.parent.Title"
              class="form-control"
              placeholder="Program Name"
              :disabled="disabled"
            >
          </div>

          <div class="form-group col-md-6">
            <label>Program ID</label>
            <input
              type="text"
              id="txtProgramID"
              name="ProgramID"
              v-model="ProgramInfo.parent.ProgramID"
              class="form-control"
              placeholder="Program ID"
              :disabled="disableProgramID"
            >
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Project Name</label>
            <input
              type="text"
              id="txtProjectName"
              v-model="ProgramInfo.parent.Alias"
              class="form-control"
              placeholder="Project Name"
              :disabled="disabled"
            >
          </div>

          <div class="form-group col-md-6">
            <label class="required-label">Investment</label>
            <kendo-multiselect
              :id="'InvestmentMultiSelect'"
              v-model="ProgramInfo.parent.InvestmentId"
              class="form-control"
              :data-source="InvestmentDropdown"
              :data-text-field="'Title'"
              :data-value-field="'Id'"
              :placeholder="'Select Investment'"
              :filter="'contains'"
              :disabled="disabled"
              :maxSelectedItems=1
            ></kendo-multiselect>
          </div>

        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>EIN</label>
            <input
              type="text"
              id="txtEIN"
              name="EIN"
              v-validate="'required'"
              v-model="ProgramInfo.parent.EIN"
              class="form-control"
              placeholder="EIN"
              :disabled="disabled"
            >
          </div>
          <div class="form-group col-md-6">
            <label>Formation Date</label>
            <div class="input-group">
              <kendo-datepicker
                placeholder="Select Date"
                :value='ProgramInfo.parent.FormationDate'
                v-model='ProgramInfo.parent.FormationDate'
                :format="'MM/dd/yyyy'"
                id="dtProgFormationDate"
                width="100%"
                @open="_setCurrentDateifNull"
              >
              </kendo-datepicker>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Income Source</label>
            <kendo-multiselect
              v-model="ProgramInfo.parent.IncomeSource"
              class="form-control"
              :data-source="dropdowns.IncomeSource.dataSource"
              :data-text-field="'Option'"
              :data-value-field="'Option'"
              :placeholder="'Select Income Source'"
              :filter="'contains'"
              :disabled="disabled"
            ></kendo-multiselect>
          </div>
          <div class="form-group col-md-6">
            <label>State Source</label>
            <kendo-multiselect
              v-model="ProgramInfo.parent.StateSource"
              class="form-control"
              :data-source="dropdowns.StateSource.dataSource"
              :data-text-field="'Option'"
              :data-value-field="'Option'"
              :placeholder="'Select State Source'"
              :filter="'contains'"
              :disabled="disabled"
            ></kendo-multiselect>
          </div>


        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-md-12 section-title-group accordion-pad">
          <label class="accordion section-title">Comments/Notes</label>
        </div>
      </div>
      <div class="panel">
        <div class="form-row">
          <div class="form-group col-md-12">
            <textarea
              class="form-control"
              v-model="ProgramInfo.parent.Note"
              rows="2"
              cols="50"
              :disabled="disabled"
            ></textarea>
          </div>
        </div>
      </div>
      <br>
      <!-- <button  @click.prevent="UnockVestingSchedule()">UnLock</button> -->
      <div class="form-row">
        <div class="col-md-12 accordion-pad">
          <label class="accordion section-title">Class Information</label>
        </div>
      </div>
      <div class="panel">
        <div class="form-row">
          <div class="form-group col-md-12">
            <BaseGrid
              :mode="mode"
              :config="UnitClassConfig"
              :dropdownOptions="UnitClassDropDowns"
              :data="ProgramInfo.children.UnitClass"
              @DeleteItem="UnitClassDeleteitem"
              @calculatedColumn="SaveInCell"
            ></BaseGrid>
          </div>
        </div>
      </div>
      <br>
      <p v-if="disabledUnitClassArray.length>0 && !disabled"> <b>Note</b>: The Greyed Out Unit Class for the Program has already issued Units and the Standard Vesting Schedule has been locked down. Please contact EY for modification</p>
      <div class="form-row">
        <div class="col-md-12 accordion-pad">
          <Label class="accordion section-title">Vesting Schedule</Label>
        </div>
      </div>
      <div class="panel">
        <div class="form-row">
          <div class="form-group col-md-12">
            <BaseGrid
              :mode="mode"
              :config="VestingScheduleConfig"
              :dropdownOptions="VestingScheduleDropDowns"
              :data="ProgramInfo.children.VestingSchedule"
              @DeleteItem="VestingDeleteitem"
            ></BaseGrid>
          </div>
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-md-12 accordion-pad">
          <label class="accordion section-title active">Partners</label>
        </div>
      </div>
      <div class="panel" style="display:block;">
        <!-- <Label v-if="formDisplay">Partners</Label> -->
        <BaseToolBar
          :config="PartnerUnitToolbarConfig"
          @buttonClicked="PartnerToolBarClick"
        ></BaseToolBar>
        <div class="row no-gutters">
          <div class="col-md-12">
            <BaseGrid
              :excelExport="excelExport"
              :group="ProgramGridGrouping"
              :aggregate="ProgramGridAggregate"
              :mode="'readonly'"
              :config="PartnerUnitGridConfig"
              :data="PartnerData"
            ></BaseGrid>
          </div>
          <!-- {{ProgramInfo}}    -->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
//import { VestingClassData  } from "@/local-data/VestingClassData.js";
import BaseGrid from "@/components/base/BaseGrid.vue";
import moment from "moment";
import { UnitClassConfig, VestingScheduleConfig,InvestmentConfig } from "./ProgramFormConfig.js";

import apiUtil from "@/services/apiUtil.js";
//import customAxios from "@/services/customAxios.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import _ from "lodash";
import { mapActions, mapGetters, mapState } from 'vuex';
import funcUtil from "@/services/funcUtil.js";
import { isNullOrUndefined } from "util";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import {
  PartnerUnitGridConfig,
  PartnerUnitToolbarConfig,
  ProgramInfoConfig
} from "@/views/reports/ProgramReportConfig.js";

export default {
  name: "ProgramForm",
  props: {
    ProgramInfo: {},
    ProgramLabel: {},
    PartnerData:{},
    PartnerConfig:{},
    PartnerToolBarConfig:{},
    ProgramGridAggregate:{},
    ProgramGridGrouping:{},
    disabled: { default: false },
    displayErrors: { default: false },
    // UnitClassColumnOptions:{},
    disableGridToolbar:{default: false},
    disableProgramID : {default:true},
    selectedDate:{}
  },
  components: {
    BaseGrid,
    BaseToolBar
  },
  mixins: [apiUtil,funcUtil,toolbarUtility],
  // watch: {
  //   //Only for Initial Issuance: read InvestmentID from user and assign Id
  //     "ProgramInfo.parent.InvestmentID": function(newVal) {
  //         //this.ProgramInfo.parent.InvestmentId=JSON.parse("[" + (newVal) + "]");
  //     },
  //       deep: true
  // },
  computed: {
    ...mapGetters("getModule",["withFilter","getLocalInputControls"]),
    ...mapState("postModule",["response"]),
    mode: function() {
      if (this.disabled) {
        return "readonly";
      } else if(this.disableGridToolbar){
        return "inline";
      }else{
        return "incell";
      }
    },
    form() {
        let parent = this.$parent;

        while (parent && parent.$options._componentTag !== 'data-form') {
            parent = parent.$parent;
        }

        return parent;

}
  },
  data: function() {
    return {
      PartnerUnitGridConfig,
      PartnerUnitToolbarConfig,
      VestingScheduleConfig,
			UnitClassConfig,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        PartnerStatus: { model: "", dataSource: [] },
        PartnerType: { model: "", dataSource: [] },
        UnitClass: { model: "", dataSource: [] },
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] },
        StateSource: { model: "", dataSource: [] },
        IncomeSource: { model: "", dataSource: [] },
        SubjectToVesting: { model: "", dataSource: [] },
      },
      UnitClassDropDowns:{},
      VestingScheduleDropDowns:{},
      InvestmentDropdown:[],
      YearOptions:[{"Option":0},{"Option":1},{"Option":2},{"Option":3},{"Option":4}],
      pageErrors:[],
      UnitClassColumnOptions:[],
      NonVestedUnitClasses:[],
      VestedUnitClasses:[],
      VestingGridClasses:[],
      disabledUnitClassArray:[],
      disableDone: false,
      lockVestingSchedule:true
    };
  },

  methods: {
    ...mapActions("postModule",["CreateItems"]),
    ...mapActions("getModule",["GetItems"]),
    UnitClassDeleteitem: function(e) {
      e.preventDefault();
      //alert("delete from unit class");
      this.$emit("UnitClassDeleteitem", e);
    },
    VestingDeleteitem: function(e) {
      e.preventDefault();
      // alert("delete from Vesting Schedule");
      this.$emit("VestingDeleteitem", e);
    },


    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });

        //Get thE Investment Dropdown List
        this.GetInvestmentlookUps("");

        //Filling the Drop down options for the Grid DropDown Columns
        this.UnitClassDropDowns.PartnerType= this.dropdowns.PartnerType.dataSource;
        this.VestingScheduleDropDowns.UnitType= this.dropdowns.UnitType.dataSource;
        this.VestingScheduleDropDowns.VestingType= this.dropdowns.VestingType.dataSource.slice();
        this.VestingScheduleDropDowns.UnitClass=this.UnitClassColumnOptions; //coming from the UC Grid databound
        this.VestingScheduleDropDowns.Year=this.YearOptions
        this.UnitClassDropDowns.SubjectToVesting= this.dropdowns.SubjectToVesting.dataSource;
      // });
    },
    onSaveChanges(e) {
      console.log("Saved Changes");
      let displayedData = $("#classKendoGrid")
        .data()
        .kendoGrid.dataSource.view();
      //var displayedDataAsJson=JSON.stringify(displayedData);
      this.vestingClassJsonData[this.ProgramInfo.ClassType] = displayedData;
      this.getVestingSchedule().data = displayedData;
    },
    onDisableClasses(e){
      console.log("onDisableClasses....");

    },
    Validate(){
            const self=this;
            self.pageErrors = [];
            let form=self.ProgramInfo.parent;
        //Form Validation

            if (!form.Title) {
                self.pageErrors.push("Program (Legal Entity) Name is required");
            }
            //Special Char Vaidation
            if (self._validateSpecialCharacter(form.Title,"singleline")) {
              self.pageErrors.push(`Program (Legal Entity) Name cannot have ${this.SingleLineSpecialChars}  Characters`);
            }
            if (self._validateSpecialCharacter(form.EIN,"singleline")) {
              self.pageErrors.push(`EIN cannot have ${this.SingleLineSpecialChars}  Characters`);
            }
            if (self._validateSpecialCharacter(form.Alias,"singleline")) {
              self.pageErrors.push(`Project Name cannot have ${this.SingleLineSpecialChars}  Characters`);
            }

            if (self._validateSpecialCharacter(form.Note,"multiline")) {
              self.pageErrors.push(`Note cannot have ${this.MultiLineSpecialChars}  Characters`);
            }

            if (!form.InvestmentId.length>0) {
                self.pageErrors.push("Investment is required");
            }
        //UnitClass Grid Validation
            let unitClassGrid=self.ProgramInfo.children.UnitClass;

            if (unitClassGrid.length==0){
              //unit class not avaiable
              self.pageErrors.push("Unit Class Table: Atleast one Unit Class is required");
            }else{
              //unit class is avaiable
              let bUnitClass = false, bUnitPrice = false, bOwnership = false, bSubjectToVesting = false, bUCName = false, bNote = false,bPartnerType=false;
              unitClassGrid.forEach(UCItem => {
                if (!UCItem.UnitClass && !bUnitClass) {
                  self.pageErrors.push("Unit Class Table: Unit Class name should not be empty");
                  bUnitClass = true;
                }
                if (UCItem.UnitClass.substring(0,5).toLowerCase() != "class" && !bUCName && !bUnitClass) {
                  self.pageErrors.push("Unit Class Table: Unit Class name must start with the word 'Class'");
                  bUCName = true;
                }
                if (self._validateSpecialCharacter(UCItem.UnitClass,"singleline")) {
                  self.pageErrors.push(`Unit Class Table: Unit Class cannot have ${this.SingleLineSpecialChars}  Characters`);
                }

                let partnerTypeIndex = self.dropdowns.PartnerType.dataSource.findIndex(f => f.Option == UCItem.PartnerType)
                if ((partnerTypeIndex < 0 || !UCItem.PartnerType) && !bPartnerType) {
                  self.pageErrors.push("Unit Class Table: Partner Type is Empty or Invalid");
                  bPartnerType=true;
                }
                if ((UCItem.UnitPrice == undefined ||UCItem.UnitPrice == null)   && !bUnitPrice) {
                  self.pageErrors.push("Unit Class Table: Unit Price should not be empty");
                  bUnitPrice = true;
                }
                if ((UCItem.Ownership == undefined||UCItem.Ownership == null) && !bOwnership) {
                  self.pageErrors.push("Unit Class Table: Ownership should not be empty");
                  bOwnership = true;
                }
                let subVestIndex = self.dropdowns.SubjectToVesting.dataSource.findIndex(f => f.Option == UCItem.SubjectToVesting)
                if ((subVestIndex <0 || !UCItem.SubjectToVesting) && !bSubjectToVesting) {
                  self.pageErrors.push("Unit Class Table: Subject To Vesting is Empty or Invalid");
                  bSubjectToVesting = true;
                }
                if(UCItem.Note != null && UCItem.Note != undefined ){
                  if (UCItem.Note.length > 255 && !bNote) {
                    self.pageErrors.push("Unit Class Table: Note should not be more than 255 characters");
                    bNote = true;
                  }
                }
                if (self._validateSpecialCharacter(UCItem.Note,"singleline")) {
                  self.pageErrors.push(`Unit Class Table: Note cannot have ${this.SingleLineSpecialChars}  Characters`);
                }

              });
              //alert(_.sumBy(unitClassGrid, 'Ownership')*100);
               // alert(_.round(_.sumBy(unitClassGrid, 'Ownership')*100,2))
              if ( _.round(_.sumBy(unitClassGrid, 'Ownership')*100,2)!=100) {
                self.pageErrors.push("Unit Class Table: The Total Ownership Percentage should be 100");
              }

            }


         //Vesting Classes Validation
         //let nonVestedClass=_.difference(self.VestingGridClasses,self.VestedUnitClasses)
         //console.log(nonVestedClass)
        //  if (nonVestedClass && nonVestedClass.length>0) {
        //    self.pageErrors.push(`Vesting Schedule Table: ${_.uniq(nonVestedClass)} Cannot be Vested as it is not Subject To Vesting.` );
        //  }

        //Vesting Schedule Grid Validation
            let vestingScheduleGrid=self.ProgramInfo.children.VestingSchedule
            if (vestingScheduleGrid.length!=0){
              //Vesting Schedule is avaiable

              let bVSUnitClass = false, bVSVestingType = false, bVSYear = false, bVSUnitType = false,
              bVSVestingDate = false, bVSPercentage = false, bVSNote = false,bVSNonVestingType=false;

              vestingScheduleGrid.forEach(VSItem => {
                if (!VSItem.UnitClass && !bVSUnitClass) {
                  self.pageErrors.push("Vesting Schedule Table: Unit Class should not be empty");
                  bVSUnitClass = true;
                }
                let unitTypeIndex = self.dropdowns.UnitType.dataSource.findIndex(f => f.Option == VSItem.UnitType)
                if ((unitTypeIndex<0 || !VSItem.UnitType) && !bVSUnitType) {
                  self.pageErrors.push("Vesting Schedule Table: Unit Type is Empty or Invalid");
                  bVSUnitType = true;
                }
                let vestingTypeIndex = self.dropdowns.VestingType.dataSource.findIndex(f => f.Option == VSItem.VestingType)
                if ((vestingTypeIndex<0 || !VSItem.VestingType) && !bVSVestingType) {
                  self.pageErrors.push("Vesting Schedule Table: Vesting Type is Empty or Invalid");
                  bVSVestingType = true;
                }
                if ((VSItem.Year == undefined ||VSItem.Year == null) && VSItem.VestingType == "Standard" && !bVSYear) {
                  self.pageErrors.push("Vesting Schedule Table: Year should not be empty for the 'Standard' Vesting Type");
                  bVSYear = true;
                }
                //Removed validation For Cliff Vesting Date
                if (VSItem.VestingType!="Cliff" && (VSItem.VestDate == undefined ||VSItem.VestDate == null) && !bVSVestingDate) {
                  self.pageErrors.push("Vesting Schedule Table: Vesting Date should not be empty for Standard Vesting Type");
                  bVSVestingDate = true;
                }
                if ((VSItem.Percentage == undefined ||VSItem.Percentage == null) && !bVSPercentage) {
                  self.pageErrors.push("Vesting Schedule Table: Vesting Percentage should not be empty");
                  bVSPercentage = true;
                }
                if(VSItem.Note != null && VSItem.Note != undefined ){
                  if (VSItem.Note.length > 255 && !bVSNote) {
                    self.pageErrors.push("Vesting Schedule Table: Note should not be more than 255 characters");
                    bVSNote = true;
                  }
                }
                if (self._validateSpecialCharacter(VSItem.Note,"singleline")) {
                  self.pageErrors.push(`Vesting Schedule Table: Note cannot have ${this.SingleLineSpecialChars}  Characters`);
                }
                //NonVesting Type
                if (self.NonVestedUnitClasses.includes(VSItem.UnitClass)&& !bVSNonVestingType && (VSItem.VestingType.trim().toLowerCase()!="cliff" || VSItem.Year!=0 || VSItem.Percentage!=1)) {
                  self.pageErrors.push("Vesting Schedule Table: For Non-Vested Unit Class, Vesting Type can only be Cliff, Year=0 and Percentage=100");
                  bVSNonVestingType = true;
                }

              });

              if(!bVSUnitClass && !bVSVestingType){
              let unitClassGrouped =_.groupBy(vestingScheduleGrid,"UnitClass");
              console.log("unitClassGrouped ",unitClassGrouped)
                // console.log(_.sumBy(unitClassGrouped["Class A"], 'Percentage'))
                _.forEach(unitClassGrouped,function(classVal,classKey){
                  let unitTypeGrouped =_.groupBy(unitClassGrouped[classKey],"UnitType");
                  _.forEach(unitTypeGrouped,function(unitVal,Unitkey){
                    //let bHasCliff=false;
                    let intCliffCount=0;

                    //Further group By Vesting Type
                    let vestingTypeGrouped =_.groupBy(unitTypeGrouped[Unitkey],"VestingType");
                      if (vestingTypeGrouped && vestingTypeGrouped.Standard && vestingTypeGrouped.Standard.length!=5 ) {
                          self.pageErrors.push(`Vesting Schedule Table: ${classKey} Unit Type ${Unitkey} and Vesting Type Standard should have Exactly 5 rows for Year 0 to 4 `)
                      }
                    console.log("vestingTypeGrouped ",vestingTypeGrouped)
                    _.forEach(vestingTypeGrouped,function(vestingVal,Vestingkey){
                          if (_.round(_.sumBy(vestingTypeGrouped[Vestingkey], 'Percentage')*100,2)!=100) {
                          self.pageErrors.push(`Vesting Schedule Table: Invalid Vesting Schedule (sum must equal 100%) for ${classKey} Unit Type ${Unitkey} and Vesting Type ${Vestingkey} `)
                          }

                          if (Vestingkey.toLowerCase()=="cliff") {
                            //bHasCliff=true;
                            intCliffCount=vestingVal.length;
                          }

                          //ignore Year 0 and percentage 0 record for Cliff Vesting Type
                          // console.log("Unitkey ",Unitkey);

                          let bVSYearPercentageZero =false,bVSYearNotZero =false,elementYear=[]
                          vestingTypeGrouped[Vestingkey].forEach(element => {
                            if(Vestingkey == "Standard"){
                              elementYear.push(element.Year)
                              if(element.Year == 0 && element.Percentage == 0 ){
                                bVSYearPercentageZero =true;
                              }
                            }else{
                               if(element.Year != 0){
                                bVSYearNotZero =true;
                              }
                            }
                          });
                          let missingYear=_.difference([0,1,2,3,4],elementYear);

                          if (Vestingkey == "Standard" && missingYear.length>0){
                            self.pageErrors.push(`Vesting Schedule Table: Missing Year ${missingYear} for ${classKey} Unit Type ${Unitkey} and Vesting Type ${Vestingkey} `)
                          }

                          if(!bVSYearPercentageZero && Vestingkey == "Standard"){
                            self.pageErrors.push(`Vesting Schedule Table: Missing or invalid Vesting Start Date (a record with Year equals 0 and Percentage equals 0%) for ${classKey} Unit Type ${Unitkey} and Vesting Type ${Vestingkey} `)
                          }


                    })
                    //Cliff Record Check
                    if(intCliffCount>1){
                      self.pageErrors.push(`Vesting Schedule Table: Cannot Have Multiple Cliff Record for ${classKey} and Unit Type ${Unitkey}`)
                    }
                  })
                })
              }
            }

        //Validation failed or success
            return self.pageErrors.length>0 ? false:true
        },

    UnitClassGridDataBound(){
      let self=this;
      self.disabledUnitClassArray=[];
      self.NonVestedUnitClasses=[];
      self.UnitClassColumnOptions = [];
      self.VestingScheduleDropDowns.UnitClass = [];
      let UnitClassItems = JSON.parse(JSON.stringify($("#ProgramClassInfoGrid").data().kendoGrid.dataSource.data()));
      self._kendoColumnToUpper("ProgramClassInfoGrid",["UnitClass","PartnerType","SubjectToVesting"])
      //filling the Unit class dropdown value from the response
      UnitClassItems.forEach(UCItem => {
        self.UnitClassColumnOptions.push({
                  "Option": UCItem.UnitClass
              });
        if (UCItem.SubjectToVesting !=undefined && UCItem.SubjectToVesting.toLowerCase()=="no") {
          self.NonVestedUnitClasses.push(UCItem.UnitClass);
        }else if (UCItem.SubjectToVesting !=undefined && UCItem.SubjectToVesting.toLowerCase()=="yes" 
          && UCItem.UnitIssued != null && UCItem.UnitIssued.toLowerCase()=="yes") {
          //self.VestedUnitClasses.push(UCItem.UnitClass);
          self.disabledUnitClassArray.push(UCItem.UnitClass);
        }
      });
      self.VestingScheduleDropDowns.UnitClassColumnOptions=this.UnitClassColumnOptions;
      self.VestingScheduleDropDowns.UnitClass=this.UnitClassColumnOptions;
     },
    VestingGridDataBound(e){
      //TODO
      let self=this;
      self.VestingGridClasses=[];
      //Disable  Rows With "UnitIssued" true for corresponding Class and Type Standard in UnitClass Grid
      let grid = $("#ProgramVestingScheduleGrid").data("kendoGrid");
      self._kendoColumnToUpper("ProgramVestingScheduleGrid",["VestingType","UnitClass"])
      if (this.disabledUnitClassArray.length>0 && self.lockVestingSchedule) {
       setTimeout(() => {
         self.disableUnitClassRows(self);
         self.disableVestingScheduleRows(self);
       }, 10);
       }
     },
   disableUnitClassRows(self){
          let disabledUnitClass = self.disabledUnitClassArray;
          let grid = $("#ProgramClassInfoGrid").data("kendoGrid");
          grid.tbody.find('tr').each(function () {
            let dataItem = grid.dataItem(this);
              if (self.lockVestingSchedule && dataItem.UnitIssued && dataItem.UnitIssued.toLowerCase() == 'yes') {
                  self.disabledUnitClassArray.push(dataItem.UnitClass)
                  $(this).addClass('disableRow');
              }else{
                $(this).removeClass('disableRow');
              }
          })
          if(!self.lockVestingSchedule){
            self.disabledUnitClassArray=[];
          }
          self.disableDone = true;
    
   },
    disableVestingScheduleRows(self){
      //Disable  Rows With "UnitIssued" true for corresponding Class and Type Standard in UnitClass Grid
      let grid = $("#ProgramVestingScheduleGrid").data("kendoGrid");
      self._kendoColumnToUpper("ProgramVestingScheduleGrid",["VestingType","UnitClass"])
      if (this.disabledUnitClassArray.length>0 && self.lockVestingSchedule) {
        let disabledUnitClass = self._removeArrayDupes(self.disabledUnitClassArray);
          for (let i = 0; i < disabledUnitClass.length; i++) {
            grid.tbody.find('tr').each(function () {
            let dataItem = grid.dataItem(this);
            //let dataItem = jQuery.extend(true, {}, origDataItem)
               self.VestingGridClasses.push(dataItem.UnitClass)
               if (dataItem.UnitClass.toLowerCase() == disabledUnitClass[i].toLowerCase()) {
                  $(this).addClass('disableRow');
                }
            })
          }
        }else{
            grid.tbody.find('tr').each(function () {
            let dataItem = grid.dataItem(this);
              $(this).removeClass('disableRow');
            })
        }
        self.disableDone = true;
      
   },
     GetInvestmentlookUps(investmentId){
          let _self = this;
          //let result = this.withFilter(InvestmentConfig.list);
          if ( this.withFilter(BaseModelInvestment.list).length > 0){
             let result =  _self.withFilter(BaseModelInvestment.list);
             this.$set(this,'InvestmentDropdown',result)

          } else {
            //console.log("getting investment lookups getting items");
             _self.GetItems(BaseModelInvestment).then(result=>this.$set(this,'InvestmentDropdown',result));
             //this.$set(this,'InvestmentDropdown',result)
          }

          if (investmentId!="") {
            let iid = JSON.parse("[" + (investmentId) + "]");
            _self.$set(this.ProgramInfo.parent,'InvestmentId',iid)
            //this.ProgramInfo.parent.InvestmentId= JSON.parse("[" + (investmentId) + "]")
            console.log("Inevetment ID Created " ,investmentId)
          }

       
        },
        SaveInCell:function(e) {
            let _self = this;
            this.ProgramInfo.children.UnitClass =  this.GetCurrentGridData("ProgramClassInfoGrid");
            // console.log("Unit Class Arrray ",this.ProgramInfo.children.UnitClass);
            setTimeout(function(){
                let UnitClassItems = _self.ProgramInfo.children.UnitClass;
                  //filling the Unit class dropdown value from the response
                UnitClassItems.forEach(
                    function(item)
                    {
                        if ((item.UnitClass != '') && (!_self.UnitClassColumnOptions.some(uc => uc.Option === item.UnitClass)))
                        {
                            _self.UnitClassColumnOptions.push({
                                  "Option": item.UnitClass
                              });
                          if (item.SubjectToVesting !=undefined && item.SubjectToVesting.toLowerCase()=="no")
                          {
                            _self.NonVestedUnitClasses.push(item.UnitClass);
                          }

                        }
                  })
              },300);
        },
        GetCurrentGridData(gridId) {
            const grid = $("#" + gridId).data("kendoGrid");
            let gridArray = [];
            let gridData = grid.dataSource.data();
            for (let i = 0; i < gridData.length; i++) {
                let element = gridData[i];
                gridArray.push(element)
            }
            return gridArray;
            //console.log(this.ProgramInfoTemplate)
        },
      editUnitClassGrid(e){
          let grid = $("#ProgramClassInfoGrid").data("kendoGrid");
          // console.log(e);
          if (e.model.isNew() == false) {
            let fieldName = e.container.find("input").attr("name");
            // var columnIndex = $("#ProgramClassInfoGrid").find(".k-grid-header [data-field=UnitClass]").index();
            // var fieldName = grid.thead.find("th").eq(columnIndex).data("field");
            if(fieldName == "UnitClass"){
              grid.closeCell(); // prevent editing
              // e.preventDefault();
            }
          }
        },

    editVestingGrid(e){
          //let grid = $("#ProgramVestingScheduleGrid").data("kendoGrid");
          //console.log(e)
          if (this.disabledUnitClassArray.includes(e.model.UnitClass) || this.NonVestedUnitClasses.includes(e.model.UnitClass)) {
            e.model.set('VestingType','Cliff');
          let index = this.VestingScheduleDropDowns.VestingType.findIndex(x => x.Option.toLowerCase()=="standard");
          if (index>=0){
            this.VestingScheduleDropDowns.VestingType.splice(index,1);
            }
          }else{
           if(this.VestingScheduleDropDowns.VestingType.findIndex(x => x.Option.toLowerCase()=="standard")<0){
              this.VestingScheduleDropDowns.VestingType.unshift({"Option":"Standard"})
           };
          }

          //Cliff Year be "NA/0" and Percentage 100%
          if (e.model.VestingType.toLowerCase()=="cliff" && this.NonVestedUnitClasses.includes(e.model.UnitClass)) {
            e.model.set('Year',0);
            e.model.set('Percentage',1)
          }else if (e.model.VestingType.toLowerCase()=="cliff") {
            e.model.set('Year',null);
            e.model.set('Percentage',1)
          }else if(e.model.Year==null ){
            e.model.set('Year',0);
          }

          //if Standard + year 0 ,Note="Standard Vesting Start Date"
          if (e.model.VestingType.toLowerCase()=="standard" && e.model.Year==0) {
            e.model.set('Note','Standard Vesting Start Date');
          }else{
            if (e.model.Note == "Standard Vesting Start Date") {
              e.model.set("Note","")
            }
          }

          // After Issuance disabledUnitClassArray
          if (this.disabledUnitClassArray.includes(e.model.UnitClass)) {
            e.model.set("AfterIssuance","Yes")
          }else{
            e.model.set("AfterIssuance","")
          }
          console.log("ProgramForm.vue editVestingGrid() ending)")
        },
        UnockVestingSchedule(){
          console.log(`unockVestingSchedule starting`)
            this.lockVestingSchedule=false;
            this.UnitClassGridDataBound();
            this.VestingGridDataBound();
            console.log(`unockVestingSchedule ending`)
        },

   PartnerToolBarClick(e) {
      switch (e.id) {
        case "detailView":
          this._displayGridColumns("ProgramPartnerGrid", {
            StandardIssuance: "show",
            StandardTransfer: "show",
            StandardForfeiture: "show",
            SupplementalIssuance: "show",
            SupplementalTransfer: "show",
            SupplementalForfeiture: "show"
          });

          break;

        case "summaryView":
          this._displayGridColumns("ProgramPartnerGrid", {
            StandardIssuance: "hide",
            StandardTransfer: "hide",
            StandardForfeiture: "hide",
            SupplementalIssuance: "hide",
            SupplementalTransfer: "hide",
            SupplementalForfeiture: "hide"
          });

          break;

        case "btnRefresh":
          this.getProgramInformation();

          break;

        default:
          break;
      }

// let ProgramFilter = {filter: "Id eq '"+this.criteriaData.Program+"'"}
//         let ProgramName = this.withFilter(this.BaseModelProgram.list,ProgramFilter)[0];
      let headerList=[
        {id:"Program Name", value:this.ProgramInfo.parent.Title},
        {id:"As of", value:kendo.toString(this.ProgramInfo.selectedDate, "MM/dd/yyyy")},
        {id:"Report Generated On", value:kendo.toString(new Date, "MM/dd/yyyy")},
        {id:"Formation Date",value: moment(this.ProgramInfo.parent.FormationDate).format("MM/DD/YYYY")}
      ]
      let arguementList={
        ...arguments,
        fileName:this.ProgramInfo.parent.InvestmentTitle+"_"+kendo.toString(this.ProgramInfo.selectedDate, "MM/dd/yyyy")+"_"+"ProgramReport"+".xlsx",
        headers:headerList
      }

      this._baseToolBarEvents("ProgramPartnerGrid", arguementList);
    },
     async getInputControlData(){
      let self=this;
      let tempdata = [];
      let res = await this.GetItems({list: "InputControl"});
       _.forEach(res,function(item){
            tempdata.push(item);
        })

      return tempdata;
    },

  },
  beforeMounted(){

  },
  created() {
   
  },

  mounted() {
     this.getInputControls();
    //bind databound event to grid
  	let grid = $("#ProgramClassInfoGrid").data("kendoGrid");
    grid.bind("dataBound", this.UnitClassGridDataBound);
    grid.bind("edit", this.editUnitClassGrid);

    let vestingGrid = $("#ProgramVestingScheduleGrid").data("kendoGrid");
    vestingGrid.bind("dataBound", this.VestingGridDataBound);
    vestingGrid.bind("cellClose", this.editVestingGrid);

     $("#summaryView")[0].checked = true; //By Deafult Summary View Should be Selected when Chnaging Programs

    let acc = document.getElementsByClassName("accordion");
    let i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(e) {
      e.preventDefault();
      this.classList.toggle("active");
      let panel = $(this).parent().parent().next(".panel")[0];
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }

      $(this).parent().parent().prevAll(".panel").css("display", "none");
      $(this).parent().parent().prevAll().find(".accordion").removeClass('active');
      $(this).parent().parent().next().nextAll(".panel").css("display", "none");
      $(this).parent().parent().next().nextAll().find(".accordion").removeClass('active');
  });
}
  },


  beforeUpdate(){
   // this.disableDone = false;

  },
  // eslint-disable-next-line vue/order-in-components
   updated(){
     const self = this;
    if (self.disableDone === false ) {
          setTimeout(() => {
            self.disableUnitClassRows(self)
            self.disableVestingScheduleRows(self);
          },10);
      } 

      if (this.pageErrors.length>0) {
          $('html, body').animate({scrollTop:$('#pageErrors').position().top}, 'slow');
      }
  }
};
</script>


<style>
.mx-input:disabled,
.mx-input.disabled {
  background-color: white;
  opacity: 1 !important;
}
.form-control:disabled {
  background-color: white !important;
  opacity: 0.7 !important;
}
textarea:disabled {
  background-color: white !important;
  opacity: 0.7 !important;
}
/* input[type="radio"]{
  width: 22px;
  margin-top: 4px;
}*/
/* .addButtonClass{
  /* margin-left:70%;
} */
.disableRow{
  opacity:0.7;
  pointer-events:none;
}
.accordion-pad{
  padding:0 ;
}
.accordion {
  background-color: #eee;
  cursor: pointer;
  padding: 10px 10px 9px 10px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 16px;
  font-weight: bold;
  color: #4A4A4A;
  transition: 0.4s;
}

 .active,.accordion:hover {
  background-color: #ccc;
}

.accordion:after {
  content: '\002B';
  color: #777;
  font-size:25px;
  font-weight: bold;
  float: right;
  margin-right:5px;
  margin-top:-8px;
}

.panel {
  margin-top:15px;
  background-color: white;
  overflow: hidden;
  display:none;
  transition: max-height 0.2s ease-out;
}

.active:after {
  content: "\2212";
}
</style>